import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';
import { useDateFormat, useMoneyMask } from '@redlink/core';
import { useLocale } from '@redlink/assets/locale';
import { isMobile } from 'react-device-detect';

export const LinkReportItem = memo(
  ({ id, url, title, createDate, clickCount, style }) => {
    const { styles } = useStyle();
    const { getDateString } = useDateFormat();
    const { dictionary } = useLocale();
    const { getValue } = useMoneyMask();

    return (
      <View style={[styles.container, style]}>
        <View style={styles.bodyContainer}>
          <View style={styles.bodyTextContainer}>
            <Text style={styles.linkTitleText}>{title}</Text>
            <Button
              variant="link"
              title={url}
              style={styles.itemTextButton}
              onPress={() => window.open(url, '_blank')}
            />
          </View>
          <Space size={8} />
          <View style={styles.hitItemsContainer}>
            <HitItem
              title={dictionary.publishedDate}
              value={getDateString(createDate)}
            />
            <Space />
            <HitItem title={dictionary.allHit} value={getValue(clickCount)} />
          </View>
        </View>
      </View>
    );
  }
);

export const HitItem = memo(({ title, value }) => {
  const { styles } = useStyle();
  return (
    <View style={styles.hitItemContainer}>
      <Text style={styles.hitItemTitleText}>{title}</Text>
      <Space size={8} />
      <Text style={styles.hitItemValueText}>{value}</Text>
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {
    borderWidth: 1,
    borderColor: colors.black3,
    borderRadius: 5,
    padding: 8,
    paddingTop: 16,
  },
  itemTextButton: {
    alignSelf: 'flex-start',
    padding: 0,
  },
  bodyContainer: {
    flexDirection: isMobile ? 'column' : 'row',
  },
  bodyTextContainer: {
    flex: 1,
  },
  hitItemContainer: {},
  hitItemTitleText: {
    color: colors.gray21,
    fontSize: 12,
  },
  hitItemValueText: {
    fontSize: 14,
    color: colors.black
  },
  hitItemsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: isMobile ? 0 : 20,
  },
  linkTitleText: {
    color: colors.gray23,
    fontSize: 14,
    textAlign: 'left',
  },
}));
